export default "__VITE_ASSET__Cq9QG0Ht__"